import getDefaultUserPreferences from 'FormsUI/api/UserPreferences/getDefaultUserPreferences';
import { getUserPreferenceRequestState } from 'FormsUI/selectors/UserPreferences';
const createAction = name => `@@userPreferences/${name}`;
export const REQUEST_USER_PREFERENCES = createAction('REQUEST_USER_PREFERENCES');
export const RECEIVE_USER_PREFERENCES = createAction('RECEIVE_USER_PREFERENCES');
export const FAIL_GETTING_USER_PREFERENCES = createAction('FAIL_GETTING_USER_PREFERENCES');
const requestUserPreferences = () => ({
  type: REQUEST_USER_PREFERENCES
});
const receiveUserPreferences = preferences => ({
  type: RECEIVE_USER_PREFERENCES,
  preferences
});
const failGettingUserPreferences = () => ({
  type: FAIL_GETTING_USER_PREFERENCES
});
export const getUserPreferences = () => (dispatch, getState) => {
  const requestState = getUserPreferenceRequestState(getState());
  if (requestState && requestState.shouldBeRequested()) {
    dispatch(requestUserPreferences());
    return getDefaultUserPreferences().then(response => {
      dispatch(receiveUserPreferences(response));
    }, () => {
      dispatch(failGettingUserPreferences());
    });
  }
  return null;
};